/**
 * Application constants
 */

export const CURRENT_MODE = import.meta.env.MODE; // 'development', 'uat', 'production'

// Environment-specific API endpoints
// You can override these individually, or set a single VITE_API_URL to force one value
const DEV_API = import.meta.env.VITE_DEV_API_URL || 'http://localhost:8000/api';
const UAT_API = import.meta.env.VITE_UAT_API_URL || 'https://worknex-uat-api.impelox.com/api';
const PROD_API = import.meta.env.VITE_PROD_API_URL || 'https://worknex-api.impelox.com/api';

// API Configuration - Priority: VITE_API_URL > mode-based fallback
export const API_BASE_URL =
  import.meta.env.VITE_API_URL ||
  (CURRENT_MODE === 'production' ? PROD_API : CURRENT_MODE === 'uat' ? UAT_API : DEV_API);

const parsedMaxUpload = Number(
  import.meta.env.VITE_MAX_UPLOAD_SIZE_MB ?? import.meta.env.VITE_MAX_UPLOAD_MB ?? 100
);

export const MAX_UPLOAD_SIZE_MB = Number.isFinite(parsedMaxUpload) && parsedMaxUpload > 0
  ? parsedMaxUpload
  :100;

export const MAX_UPLOAD_SIZE_BYTES = MAX_UPLOAD_SIZE_MB * 1024 * 1024;

export const TOKEN_KEY = 'jira_clone_token';
export const REFRESH_TOKEN_KEY = 'jira_clone_refresh_token';
export const USER_KEY = 'jira_clone_user';

export const TASK_STATUS = {
  TODO: 'todo',
  IN_PROGRESS: 'in_progress',
  IN_REVIEW: 'in_review',
  DONE: 'done',
  BACKLOG: 'backlog',
} as const;

export const TASK_STATUS_LABELS = {
  todo: 'To Do',
  in_progress: 'In Progress',
  in_review: 'In Review',
  done: 'Done',
  backlog: 'Backlog',
};

export const TASK_PRIORITY = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
  CRITICAL: 'critical',
} as const;

export const TASK_PRIORITY_LABELS = {
  low: 'Low',
  medium: 'Medium',
  high: 'High',
  critical: 'Critical',
};

export const TASK_TYPE = {
  STORY: 'story',
  BUG: 'bug',
  TASK: 'task',
  EPIC: 'epic',
} as const;

export const TASK_TYPE_LABELS = {
  story: 'Story',
  bug: 'Bug',
  task: 'Task',
  epic: 'Epic',
};

export const USER_ROLE = {
  ADMIN: 'admin',
  MANAGER: 'manager',
  DEVELOPER: 'developer',
  VIEWER: 'viewer',
} as const;

export const BUG_SEVERITY = {
  MINOR: 'minor',
  MAJOR: 'major',
  CRITICAL: 'critical',
  BLOCKER: 'blocker',
} as const;

export const KANBAN_COLUMNS = [
  { id: 'todo', title: 'To Do', status: TASK_STATUS.TODO },
  { id: 'in_progress', title: 'In Progress', status: TASK_STATUS.IN_PROGRESS },
  { id: 'in_review', title: 'In Review', status: TASK_STATUS.IN_REVIEW },
  { id: 'done', title: 'Done', status: TASK_STATUS.DONE },
];


